<template>
	<Modal @close="action" v-if="show" :draggable="false">
		<template slot="title">Packing Print History</template>
		<template slot="body">
			<table class="list_tbl">
				<thead>
					<tr>
						<th></th>
						<th>User Id</th>
						<th>Print Time</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(history, index) in list" :key="index">
						<td>{{ index + 1 }}</td>
						<td>{{ history.userId }}</td>
						<td>
							<span v-if="history.date">{{ history.date | moment('timezone', $session.get('time_zone'), 'MM-DD-yyyy HH:mm:ss') }}</span>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="popup_bottom">
				<a href="javascript:void(0);" @click="action()" class="search_bt mgr_15">Close</a>
			</div>
		</template>
	</Modal>
</template>
<script>
import Modal from '@/components/common/Modal';
import { apiSelectPackingPrintHistory } from '@/api/sales/invoice';
export default {
	name: 'packingPrintHistoryModal',
	components: { Modal },
	props: ['invoice_no'],
	data() {
		return { show: false, list: [] };
	},
	methods: {
		async action() {
			if (!this.show) {
				const { data } = await apiSelectPackingPrintHistory(this.invoice_no);
				this.list = data;
			}
			this.show = !this.show;
		},
	},
};
</script>
